import { Routes, Route, useNavigate } from "react-router-dom";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import Retail from "./Screens/Retail";
import InvoiceList from "./Screens/InvoiceList";
import Home from "./Screens/Home";
import EditInvoice from "./Screens/EditInvoice";
import Login from "./Screens/auth/Login";
import ProtectedRoute from "./ProtectedRoute";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { getUserByToken } from "./apis/authSlice";
import { removeAuthToken } from "./utils";
import { toast } from "react-toastify";
import WholeSaleAddInvoice from "./Screens/WholeSaleAddInvoice";
import ItemList from "./Screens/ItemList";

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    async function callAPI() {
      const response = await dispatch(getUserByToken());
      if (
        response.type.includes("rejected") &&
        response.payload.response.data.error
      ) {
        removeAuthToken();
        localStorage.removeItem("adminToken");
        navigate("/auth/login");
        toast.error("Time out");
      }
    }
    callAPI();
  }, []);

  return (
    <div>
      <Routes>
        <Route path="/auth/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/wholesaleaddinvoice"
          element={
            <ProtectedRoute>
              <WholeSaleAddInvoice />
            </ProtectedRoute>
          }
        />
        <Route
          path="/editinvoice/:id?"
          element={
            <ProtectedRoute>
              <EditInvoice />
            </ProtectedRoute>
          }
        />
        <Route
          path="/retail"
          element={
            <ProtectedRoute>
              <Retail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/invoicelist"
          element={
            <ProtectedRoute>
              <InvoiceList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/itemlist"
          element={
            <ProtectedRoute>
              <ItemList />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
